import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=49eafc86&scoped=true&"
import script from "./Navigator.vue?vue&type=script&lang=ts&"
export * from "./Navigator.vue?vue&type=script&lang=ts&"
import style0 from "./Navigator.vue?vue&type=style&index=0&id=49eafc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eafc86",
  null
  
)

export default component.exports